const apiUrl = "https://price-system.com/api/"; //线上
// const apiUrl = "http://localhost:3000/"; /// 测试
export { apiUrl };
